module.exports = __webpack_public_path__ + "img/ai_person_remover1.0c00610d.png";